class WebSocketService {
    static instance;
    ws = null;
    pingInterval = null;
    reconnectTimeout = null;
    wsUrl = "";
    reconnectInterval = 5000;
    pingIntervalMs = 30000;
    eventSubscribers = new Map();
    constructor() { }
    static getInstance() {
        if (!WebSocketService.instance) {
            WebSocketService.instance = new WebSocketService();
        }
        return WebSocketService.instance;
    }
    send(message) {
        if (this.ws && this.ws.readyState === WebSocket.OPEN) {
            this.ws.send(JSON.stringify(message));
        }
        else {
            console.warn("WebSocket is not open. Message not sent.");
        }
    }
    maybeSend(message) {
        if (this.ws && this.ws.readyState === WebSocket.OPEN) {
            this.ws.send(JSON.stringify(message));
        }
    }
    close() {
        if (this.ws && this.ws.readyState === WebSocket.OPEN) {
            this.ws.close();
        }
        this.stopPinging();
        if (this.reconnectTimeout) {
            clearTimeout(this.reconnectTimeout);
        }
    }
    subscribe(type, callback) {
        if (!this.eventSubscribers.has(type)) {
            this.eventSubscribers.set(type, new Set());
        }
        this.eventSubscribers.get(type).add(callback);
    }
    unsubscribe(type, callback) {
        if (this.eventSubscribers.has(type)) {
            this.eventSubscribers.get(type).delete(callback);
        }
    }
    connect(url) {
        this.wsUrl = url;
        this.ws = new WebSocket(this.wsUrl);
        this.ws.onopen = () => {
            console.log("Connected");
            this.startPinging();
        };
        // this.ws.onmessage = onMessage;
        this.ws.onmessage = (event) => {
            const message = JSON.parse(event.data);
            if (this.eventSubscribers.has(message.type)) {
                this.eventSubscribers.get(message.type).forEach((callback) => {
                    callback(message);
                });
            }
        };
        this.ws.onclose = () => {
            console.log("Disconnected");
            this.stopPinging();
            this.reconnectTimeout = setTimeout(() => this.connect(this.wsUrl), this.reconnectInterval);
        };
        this.ws.onerror = (error) => {
            console.error("WebSocket error", error);
            if (this.ws)
                this.ws.close();
        };
    }
    startPinging() {
        if (!this.ws)
            return;
        if (this.pingInterval)
            return;
        this.pingInterval = setInterval(() => {
            if (this.ws && this.ws.readyState === WebSocket.OPEN) {
                this.ws.send(JSON.stringify({
                    type: "PING",
                }));
            }
        }, this.pingIntervalMs);
    }
    stopPinging() {
        if (this.pingInterval) {
            clearInterval(this.pingInterval);
            this.pingInterval = null;
        }
    }
}
export default WebSocketService.getInstance();
